angular.module('dealerware.web.filters').filter('filterScanSource', function() {
    return function(device: string) {
        switch(device) {
            case 'mojio':
                return 'CCD 1.0';
            case 'guidepoint':
                return 'CCD 2.0';
            case 'toyota':
                return 'Toyota'
            case 'toolkit':
                return 'Mobile';
            default:
                return 'Web';
        }
    };
});
